import { useUser } from '@clerk/nextjs';
import { trpc } from '@web-app/utils/trpc';

/**
 * Whether the authenticated provider is flagged as a prescriber in Airtable
 * (`is_prescriber`). Cached for the session via React Query staleTime.
 */
export const useIsPrescriber = () => {
  const { user, isLoaded: isUserLoaded } = useUser();

  const { data, isPending, isError, error, refetch, isRefetching } =
    trpc.providerProfile.getIsPrescriber.useQuery(undefined, {
      enabled: Boolean(user),
      staleTime: Infinity,
    });

  return {
    isPrescriber: data?.isPrescriber ?? false,
    isLoading: !isUserLoaded || (Boolean(user) && isPending),
    isError,
    error,
    refetch,
    isRefetching,
  };
};
